export const REMOVE_WHITE_SPACE = new RegExp('\\s', 'g');
export const MATCH_DOTS = new RegExp('\\.', 'gi');
export const MATCH_THOUSANDS_SEPARATOR = new RegExp('\\B(?=(\\d{3})+(?!\\d))', 'gi');
export const REGEX_GET_ONLY_NUMBERS = new RegExp(/\D/, 'g');
export const MATCH_CELLPHONE = new RegExp(/^\([1-9]{2}\) [9]{0,1}[6-9]{0,1}[0-9]{4}-[0-9]{4}$/);
export const MATCH_BIRTHDAY = new RegExp(/^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/);
